// apiService.js
(() => {
  const baseUrl = (() => {
    const host = location.hostname;
    if (
      host.includes("localhost") ||
      host.includes("127.0.0.1") ||
      host.includes("ibwt.com.tw")
    ) {
      return "https://ncapi.ibwt.com.tw/Keyword";
    } else {
      return "https://ncapi.bwt.com.tw/Keyword";
    }
  })();
  // 創建一個模擬的axios客戶端
  const keywordClient = {
    baseUrl,
    get(url) {
      return fetch(this.baseUrl + url, {
        headers: {
          accept: "text/plain",
          "Content-Type": "application/json",
        },
      }).then((response) => {
        if (!response.ok) throw new Error("API請求失敗");
        return response.json();
      });
    },
    post(url, data) {
      return fetch(this.baseUrl + url, {
        method: "POST",
        headers: {
          accept: "text/plain",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then((response) => {
        if (!response.ok) throw new Error("API請求失敗");
        return response.json();
      });
    },
    getMainGroupInfoByWebSiteSSE(promCode, setDataSource, callback) {
      const url = `${this.baseUrl}/GetMainGroupInfoByWebSiteSSE/${promCode}`;
      let mainGroupData = [];
      let airlines = [];

      // 建立 AbortController 用於取消請求
      const controller = new AbortController();
      const signal = controller.signal;

      // 使用 fetch 搭配 ReadableStream 實現 SSE
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "text/event-stream",
          "Cache-Control": "no-cache",
        },
        signal: signal, // 加入 signal 用於取消請求
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = "";

          function readStream() {
            return reader.read().then(({ done, value }) => {
              if (done) {
                callback();
                return;
              }

              buffer += decoder.decode(value, { stream: true });
              const lines = buffer.split("\n");
              buffer = lines.pop(); // 保留不完整的行

              lines.forEach(async (line) => {
                if (line.startsWith("data: ")) {
                  const data = line.slice(6); // 移除 'data: ' 前綴
                  if (data === "[DONE]") {
                    callback();
                    return;
                  }

                  try {
                    const parsedData = JSON.parse(data);
                    switch (parsedData.step) {
                      case "step1":
                        mainGroupData = parsedData.data;
                        setDataSource(mainGroupData, airlines);
                        break;
                      case "airline":
                        airlines = parsedData.data;
                        break;
                      case "step2":
                        mainGroupData = mainGroupData.map((mainGroup) => {
                          const item = parsedData.data.find(
                            (item) =>
                              item.mainGroupCode === mainGroup.mainGroupCode,
                          );
                          if (item) {
                            mainGroup.groups = item.groups;
                            mainGroup.departure = item.departure;
                          }
                          return mainGroup;
                        });
                        setDataSource(mainGroupData, airlines);
                        break;
                      case "step3":
                        mainGroupData = mainGroupData.filter(
                          (item) =>
                            item.groups.filter(
                              (group) => group.price === 99999999,
                            ).length === 0,
                        );
                        setDataSource(mainGroupData, airlines);
                        break;
                    }
                  } catch (e) {
                    console.error("解析資料錯誤:", e);
                  }
                } else if (line.startsWith("event: ")) {
                  const eventType = line.slice(7); // 移除 'event: ' 前綴
                  if (eventType === "complete") {
                    callback();
                    return;
                  }
                }
              });

              return readStream(); // 繼續讀取
            });
          }

          return readStream();
        })
        .catch((error) => {
          if (error.name === "AbortError") {
            console.log("請求已被取消");
          } else {
            console.error("SSE 連接錯誤:", error);
          }
        });

      // 返回取消函數，讓呼叫者可以取消請求
      return () => {
        controller.abort();
      };
    },
  };

  window.keywordClient = keywordClient;
})();
